import React from 'react';
import PropTypes from 'prop-types';
import Select, { components } from 'react-select';
import classNames from 'classnames';
import get from 'lodash/get';

import SubscriptionIcon from 'rebook/apps/base/components/icons/SubscriptionIcon';

import selectStyles from './selectStyles';
import styles from './style.scss';


const IndicatorsContainer = () => (
  <svg width="13" height="8" xmlns="http://www.w3.org/2000/svg">
    <path
      // eslint-disable-next-line max-len
      d="M5.309 6.38L.76 1.816A.854.854 0 0 1 1.967.608l4.557 4.557 4.51-4.51a.852.852 0 0 1 1.206 1.207l-5.758 5.78-1.2-1.236.027-.025z"
      fill="#BE5B04" />
  </svg>
);

export const SubscriptionOption = (props) => {
  return (
    <components.Option {...props}>
      {props.data.type &&
        <SubscriptionIcon width={24} height={24} type={props.data.type} extraClassName={styles.optionIcon} />}
      <span>{props.children}</span>
    </components.Option>
  );
};

export const SubscriptionValueContainer = (props) => {
  const type = get(props, 'selectProps.value.type', null);
  return (
    <div className={styles.valueTextContainer}>
      {type && <SubscriptionIcon width={24} height={24} type={type} />}
      <components.ValueContainer {...props} />
    </div>
  );
};

export const BooktypeOption = (props) => {
  return (
    <components.Option {...props}>
      {props.children}
    </components.Option>
  );
};

export const BooktypeValueContainer = (props) => {
  return (
    <React.Fragment>
      <components.ValueContainer {...props} />
    </React.Fragment>
  );
};

const SelectMenu = (
  { options, placeholder, components, selectedValue, width,
    defaultValue, extraClassName, onChange, name, isDisabled, value }
) => (
  <div className={classNames(extraClassName, styles.container)}>
    <Select
      className={`cy-jest-select-${name}`}
      classNamePrefix={`cy-jest-select-${name}`}
      defaultValue={defaultValue || options[0]}
      options={options}
      value={value}
      styles={selectStyles(width)}
      placeholder={placeholder}
      onChange={(value)=>onChange(value)}
      components= {{ IndicatorsContainer, ...components }}
      isSearchable={false}
      selectedValue={selectedValue}
      isDisabled={isDisabled} />
  </div>
);

SelectMenu.propTypes = {
  extraClassName: PropTypes.string,
  options: PropTypes.array,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  components: PropTypes.object,
  selectedValue: PropTypes.object,
  defaultValue: PropTypes.object,
  isDisabled: PropTypes.bool,
};

SelectMenu.defaultProps = {
  options: [],
  onChange: function() {},
  placeholder: '',
  components: {},
  selectedValue: {},
  extraClassName: '',
  isDisabled: false,
};

export default SelectMenu;
